import api from './api';

const leaderboardService = {
  // Get daily leaderboard
  getDailyLeaderboard: async (date, limit = 50) => {
    let url = `/leaderboard/daily`;
    const params = [];

    if (date) {
      params.push(`date=${date}`);
    }

    if (limit) {
      params.push(`limit=${limit}`);
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return api.get(url);
  },

  // Get weekly leaderboard
  getWeeklyLeaderboard: async (limit = 50) => {
    let url = `/leaderboard/weekly`;

    if (limit) {
      url += `?limit=${limit}`;
    }

    return api.get(url);
  },

  // Get monthly leaderboard
  getMonthlyLeaderboard: async (limit = 50) => {
    let url = `/leaderboard/monthly`;

    if (limit) {
      url += `?limit=${limit}`;
    }

    return api.get(url);
  },

  // Get all-time leaderboard
  getAllTimeLeaderboard: async (limit = 50) => {
    let url = `/leaderboard/all-time`;

    if (limit) {
      url += `?limit=${limit}`;
    }

    return api.get(url);
  },

  // Get winners for a specific date
  getWinnersByDate: async (date) => {
    let url = `/leaderboard/winners`;

    if (date) {
      url += `?date=${date}`;
    }

    return api.get(url);
  },

  // Save winners for a specific date
  saveWinners: async (date, winners) => {
    return api.post(`/leaderboard/winners`, {
      date,
      winners,
    });
  },

  // Notify winners for a specific date
  notifyWinners: async (date, message) => {
    return api.post(`/leaderboard/winners/notify`, {
      date,
      message,
    });
  },

  // Get user stats and entries
  getUserStats: async (userId, gameSessionId) => {
    let url = `/leaderboard/users/${userId}`;

    if (gameSessionId) {
      url += `?gameSessionId=${gameSessionId}`;
    }

    return api.get(url);
  },
};

export default leaderboardService;
